import properties from '../../../modules/ajio-util/properties';

const imgPath = `${properties.getProperty('imageBaseUrl')}/static/img/`;

const imageToPath = {
  store_circle: `${imgPath}store-circle.svg`,
  store_path: `${imgPath}store-pickup-path01.svg`,
  ajio_logo_circle: `${imgPath}ajio-logo-circle.svg`,
  uncolor_store_circle: `${imgPath}uncolor-store-circle.svg`,
  geo_location_circle: `${imgPath}geo-location-circle.svg`,
  shooping_bag_circle: `${imgPath}shooping-bag-circle.svg`,
  banner_store_desktop: `${imgPath}banner-store-desktop.svg`,
  dispatch_circle: `${imgPath}dispatch-circle.svg`,
  group_location_circle: `${imgPath}group-location-circle.svg`,
  mirror_circle: `${imgPath}mirror-circle.svg`,
  rupee_circle: `${imgPath}rupee-circle.svg`,
  banner_store_mobile: `${imgPath}banner-store-mobile.svg`,
  store_return_logo: `${imgPath}store-return-logo.svg`,
  sr_desktop_howitworks_banner: `${imgPath}store-return-howitworks01.svg`,
  sr_nearest_store: `${imgPath}nearst-store-logo.svg`,
  sr_items_with_tags: `${imgPath}items-with-tags-logo.svg`,
  sr_howitworks_instant_refund: `${imgPath}hiw-instant-refund-logo.svg`,
  sr_instant_return: `${imgPath}instant-return-logo.svg`,
  sr_more_stores: `${imgPath}more-stores-logo.svg`,
  sr_store_options: `${imgPath}store-options-logo.svg`
};

export default imageToPath;
